/* eslint-disable max-len */
import whanganui from './geodata/whanganui.json';
import northland from './geodata/northland.json';
import auckland from './geodata/auckland.json';
import waikato from './geodata/waikato.json';
import bop from './geodata/bop.json';
import gis from './geodata/gis.json';
import hb from './geodata/hb.json';
import taranaki from './geodata/taranaki.json';
import wel from './geodata/wellington.json';
import westcoast from './geodata/westcoast.json';
import canterbury from './geodata/canterbury.json';
import otago from './geodata/otago.json';
import southland from './geodata/southland.json';
import tasman from './geodata/tasman.json';
import nelson from './geodata/nelson.json';
import marlborough from './geodata/marlborough.json';
import chath from './geodata/chatham.json';
import nelsonMarlboroughTasman from './geodata/nelsonMarlboroughTasman.json';

const regions = {
  1006: northland,
  1007: auckland,
  1001: waikato,
  1008: bop,
  1009: gis,
  1010: hb,
  1011: taranaki,
  1012: whanganui,
  1013: wel,
  1018: westcoast,
  1017: canterbury,
  1020: otago,
  1021: southland,
  1016: tasman,
  1014: nelson,
  1015: marlborough,
  1019: chath,
};

const stateHighways = {
  22: northland,
  23: auckland,
  24: waikato,
  25: bop,
  26: gis,
  27: hb,
  28: taranaki,
  29: whanganui,
  30: wel,
  31: nelsonMarlboroughTasman,
  32: canterbury,
  33: westcoast,
  34: otago,
  35: southland,
};

const regiondata = {
  regions,
  stateHighways,
};

export default regiondata;
